import { FormDefinitionItem } from '../../types/generated/formDefinitionItem';
import { getRulesSetup } from '../getRulesSetup';
import * as yup from 'yup';
import {
    FieldStructure,
    NutsSelectorFieldStructure,
} from '@mercell/form-react';
import { TFunction } from 'react-i18next';

export const mapNutsSelectorField = (
    formDefinition: FormDefinitionItem,
    genericFieldStructure: FieldStructure,
    t: TFunction<string, unknown>,
    allowSelectionOfLevel1and2Locations: boolean
): NutsSelectorFieldStructure => {
    if (genericFieldStructure.associatedValidationBasedOnOtherFieldValues) {
        if (
            formDefinition.conditionalValidation?.rules &&
            genericFieldStructure.associatedValidationBasedOnOtherFieldValues
        ) {
            const conditionalValidations = getRulesSetup(
                yup.string().nullable(),
                formDefinition.conditionalValidation.rules,
                t
            );
            genericFieldStructure.associatedValidationBasedOnOtherFieldValues.rules =
                conditionalValidations;
        }
    }

    const yupType = formDefinition.isMultiSelect ? yup.array().nullable() : yup.string().nullable();

    // For UK NUTs selector, allow selection of all levels on 1, 2 and 3 when isMultiSelect is true
    // For Non UK, only allow selection of level 3
    const isUkNutsMultiSelect = formDefinition.isMultiSelect ?? false;

    return {
        ...genericFieldStructure,
        type: 'nuts-selector',
        isClearable: true,
        disableAllButNUTS3: !isUkNutsMultiSelect,
        selfDisableComponentIfNoValues: true,
        isMulti: isUkNutsMultiSelect,
        fieldToTrack: {
            fieldName: formDefinition.parentField?.fieldName ?? '',
            useSamePath: formDefinition.parentField?.useSamePath,
        },
        disableValidationIfNoNuts: true,
        validations: formDefinition.rules
            ? getRulesSetup(yupType, formDefinition.rules, t)
            : undefined,
    };
};
